import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AvatarCreationForm from "../features/generate-video/components/AvatarCreationForm";
import { useAuth } from "../context/AuthContext";

type AvatarLocationState = { returnTo?: string };

const AvatarPage: React.FC = () => {
  const { idToken } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = (location.state as AvatarLocationState | null)?.returnTo;

  const handleLeave = () => {
    if (returnTo) {
      navigate(returnTo, { replace: true });
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="min-h-screen p-6">
      <div className="mx-auto max-w-7xl">
        <div className="mb-4 flex flex-wrap items-center justify-between gap-3 border-b border-zinc-200 pb-4">
          <button
            type="button"
            onClick={handleLeave}
            className="inline-flex items-center gap-2 text-sm font-medium text-zinc-700 hover:text-zinc-900"
          >
            <span className="material-icons text-lg">arrow_back</span>
            Back
          </button>
          {returnTo && (
            <button
              type="button"
              onClick={handleLeave}
              className="rounded-lg bg-[#2f4941] px-4 py-2 text-sm font-medium text-white hover:opacity-90"
            >
              Done
            </button>
          )}
        </div>
        {idToken && <AvatarCreationForm idToken={idToken} />}
      </div>
    </div>
  );
};

export default AvatarPage;

